import { Either } from 'fp-ts/lib/Either';
import * as t from 'io-ts';
import { SearchResults } from '../../lib/dto';
import { getJSON, setJSON } from '../sessionStorage';

const STORAGE_KEY = 'jg-search-results';

const StorageData = t.type({
  url: t.string,
  results: SearchResults,
});
type StorageData = t.TypeOf<typeof StorageData>;

export function getResults(): Either<unknown, SearchResults> {
  return getJSON(STORAGE_KEY)
    .chain(data => StorageData.decode(data))
    .filterOrElse(data => data.url === window.location.href, 'URL mismatch')
    .map(data => data.results);
}

export function setResults(results: SearchResults): void {
  const storageData: StorageData = {
    url: window.location.href,
    results,
  };
  setJSON(STORAGE_KEY, storageData);
}
